module.exports = "/packs/004-855272f4ef6425303bb38c5cf48c0364.jpg";